import { type FC } from "react";
import { Input } from "@ui/Input";
import { cn } from "@/utils/tailwind";

interface NumberInputProps {
  value?: string;
  onChange: (value: string) => void;
  isError?: boolean;
  float?: boolean;
  decimalScale?: number;
  className?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  placeholder?: string;
  disabled?: boolean;
  unit?: string;
  dataTest?: string;
}

const NumberInput: FC<NumberInputProps> = ({
  onChange,
  value,
  isError,
  float = true,
  decimalScale = 4,
  className,
  onBlur,
  onFocus,
  placeholder = "",
  disabled = false,
  unit,
  dataTest,
}) => {
  const decimalRegex = float
    ? new RegExp(`^\\d*(?:\\.\\d{0,${decimalScale.toString()}})?$`)
    : /^\d*$/;

  const inputPattern = float ? `[0-9]+(\\.?[0-9]{0,${decimalScale.toString()}})?` : "\\d*";

  return (
    <div
      className={cn(
        "focus-within:ring-ring bg-background flex h-12 w-full items-center gap-1 overflow-hidden rounded-[6px] border px-[17px] focus-within:ring-1",
        isError && "border-destructive",
        disabled && "bg-card vtac:border-muted-foreground",
        className,
      )}
    >
      <Input
        id="amount"
        autoComplete="off"
        value={value ?? ""}
        placeholder={placeholder}
        data-test={dataTest}
        className="h-full w-full border-none bg-transparent p-0 focus:ring-0 focus-visible:ring-0"
        inputMode="decimal"
        pattern={inputPattern}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={e => {
          const rawValue = e.target.value.replace(",", ".");
          if (rawValue.startsWith(".")) return;
          if (decimalRegex.test(rawValue)) {
            onChange(rawValue);
          }
        }}
      />
      {unit && (
        <p className={cn("font-extralight", disabled && "text-input vtac:text-muted-foreground")}>
          {unit}
        </p>
      )}
    </div>
  );
};

export default NumberInput;
